var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('strong',[_c('img',{attrs:{"src":"/img/icons/apple-touch-icon-76x76.png","alt":""}}),_c('span',{style:('color: #8396a5')},[_vm._v("Fortknox")])])}
var staticRenderFns = []

export { render, staticRenderFns }